import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {PageNotFoundControllerComponent} from './page-not-found-controller.component';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        PageNotFoundControllerComponent
    ],
    exports: [
        PageNotFoundControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class PageNotFoundModule {}
